"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const fmtLog = (repositoryName, text) => {
  return `gatsby-plugin-prismic-previews(${repositoryName}) - ${text}`;
};
exports.fmtLog = fmtLog;
//# sourceMappingURL=fmtLog.cjs.map
